import { render, staticRenderFns } from "./report-page-builder.vue?vue&type=template&id=623d2eb9"
import script from "./report-page-builder.vue?vue&type=script&lang=js"
export * from "./report-page-builder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports